import cn from 'classnames';
import React, { FC, useMemo } from 'react';

import { CircleDivisionData, CircleDivisions } from '@.partials';
import { DEFAULT_ANALYTICS_CHART_COLORS } from '@/Components/Partials/Analytics/constants';
import { ChartDatasetValues } from '@/Types/analytics/chartsTypes';

import S from './styles.module.scss';

type GenderChartProps = {
    data: ChartDatasetValues;
    mini?: boolean;
};

export const GenderChart: FC<GenderChartProps> = ({ data, mini = false }) => {
    const circleDivisionsData = useMemo<CircleDivisionData[]>(
        () =>
            data.map((dataItem, index) => ({
                value: dataItem.value,
                color: DEFAULT_ANALYTICS_CHART_COLORS[index],
                label: dataItem.label,
                pct: dataItem.pct,
            })),
        [data]
    );

    return (
        <div className={S.wrapper}>
            <h3 className={cn(S.title, { [S['title-mini']]: mini })}>Gender</h3>
            <div className={cn(S.gender_chart, { [S['gender_chart-mini']]: mini })}>
                <CircleDivisions data={circleDivisionsData} showLegend={!mini} />
            </div>
        </div>
    );
};
